import { Outlet } from "react-router-dom";
import { DashboardHeaderContainer } from "../features/dashboard/components/DashboardHeader/DashboardHeaderContainer";
import { ChatSessionContainer } from "../features/chat/components/ChatSession/ChatSessionContainer";
import { DashboardNavigationItemsContainer } from "../features/dashboard/components/DashboardNavigationItems/DashboardNavigationItemsContainer";
import { useRedirectWhenAnonymous } from "@platform/hooks/useRedirectWhenAnonymous";
import { AppLayout } from "./AppLayout";
import { useGetUserData } from "../hooks/useGetUserData";
import useFetchNotifications from "../features/notifications/hooks/useFetchNotifications";
import { DashboardAlertBannerContainer } from "@platform/features/dashboard/components/DashboardAlertBanner/DashboardAlertBannerContainer.tsx";
import { useClosePlatformAccess } from "@platform/hooks/useClosePlatformAccess";

export type Props = {
  children?: React.ReactNode;
  title: string;
};

export function DashboardLayout({ children, title }: Props) {
  useClosePlatformAccess();
  useRedirectWhenAnonymous();

  useFetchNotifications();

  const { isLoading } = useGetUserData();

  return (
    <ChatSessionContainer>
      <AppLayout
        header={
          <DashboardHeaderContainer>
            <DashboardNavigationItemsContainer />
          </DashboardHeaderContainer>
        }
        title={title}
        isLoading={isLoading}
      >
        <DashboardAlertBannerContainer />
        {children ?? <Outlet />}
      </AppLayout>
    </ChatSessionContainer>
  );
}

export default DashboardLayout;
